export const modalViewed = {
  event_description: 'Registration Resume Flow Modal Viewed',
  object_name: 'registrationResumeModal',
  object: 'Container',
  action: 'Viewed',
  screen: 'registrationCreateAccount',
  screen_name: 'registrationCreateAccount',
}

export const buttonTapped = {
  event_description: 'Registration Resume Flow Acknowledged',
  object_name: 'registrationResumeAcknowledgement',
  object: 'Button',
  action: 'Tapped',
  screen: 'registrationCreateAccount',
  screen_name: 'registrationCreateAccount',
}
